function t(e) {
  return e.composedPath()[0] || null;
}
export {
  t as getPreciseEventTarget
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/seemly@0.3.10/~/seemly/es/dom/get-precise-event-target.js
// module id = 124
// module chunks = 41